// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"a0266e01","202":"fbd82658","396":"fcc39d75","728":"1c20b8e4","929":"d927de80"}[chunkId] + ".chunk.css";
};